import React from 'react'
import styles from './VpsExpiredModal.module.scss'
import { fullDateFormat } from '@utils/time'

interface Props {
  vps: {
    name: string
    serverDate: string
  }[]
}

const VpsExpiredModal: React.FC<Props> = ({ vps }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>Есть VPS которые надо оплатить</div>
      {vps.map((el, index) => (
        <div className={styles.row} key={index}>
          <div className={styles.name}>{el.name}</div>
          <div className={styles.date}>{fullDateFormat(el.serverDate)}</div>
        </div>
      ))}
    </div>
  )
}

export default VpsExpiredModal
